__turbopack_context__.v({
  "backBtn": "CefrQuiz-module__FJR9TG__backBtn",
  "bandPill": "CefrQuiz-module__FJR9TG__bandPill",
  "copyBtn": "CefrQuiz-module__FJR9TG__copyBtn",
  "ctaPrimary": "CefrQuiz-module__FJR9TG__ctaPrimary",
  "ctaSecondary": "CefrQuiz-module__FJR9TG__ctaSecondary",
  "languageInput": "CefrQuiz-module__FJR9TG__languageInput",
  "languageTag": "CefrQuiz-module__FJR9TG__languageTag",
  "levelBadge": "CefrQuiz-module__FJR9TG__levelBadge",
  "levelEyebrow": "CefrQuiz-module__FJR9TG__levelEyebrow",
  "material-icons": "CefrQuiz-module__FJR9TG__material-icons",
  "optionBtn": "CefrQuiz-module__FJR9TG__optionBtn",
  "optionLabel": "CefrQuiz-module__FJR9TG__optionLabel",
  "optionSelected": "CefrQuiz-module__FJR9TG__optionSelected",
  "options": "CefrQuiz-module__FJR9TG__options",
  "progressFill": "CefrQuiz-module__FJR9TG__progressFill",
  "progressHeader": "CefrQuiz-module__FJR9TG__progressHeader",
  "progressMeta": "CefrQuiz-module__FJR9TG__progressMeta",
  "progressTrack": "CefrQuiz-module__FJR9TG__progressTrack",
  "quiz": "CefrQuiz-module__FJR9TG__quiz",
  "resultCard": "CefrQuiz-module__FJR9TG__resultCard",
  "resultCopy": "CefrQuiz-module__FJR9TG__resultCopy",
  "resultCtas": "CefrQuiz-module__FJR9TG__resultCtas",
  "skillChip": "CefrQuiz-module__FJR9TG__skillChip",
  "skillGrid": "CefrQuiz-module__FJR9TG__skillGrid",
  "slideIn": "CefrQuiz-module__FJR9TG__slideIn",
  "stepCard": "CefrQuiz-module__FJR9TG__stepCard",
  "stepIcon": "CefrQuiz-module__FJR9TG__stepIcon",
  "stepLabel": "CefrQuiz-module__FJR9TG__stepLabel",
  "stepQuestion": "CefrQuiz-module__FJR9TG__stepQuestion",
  "suggestion": "CefrQuiz-module__FJR9TG__suggestion",
  "suggestions": "CefrQuiz-module__FJR9TG__suggestions",
});
